import {withRouter} from 'react-router-dom';

import AbstractByAircraft from './AbstractByAircraft';
import React from "react";

class UgoLogArchiveByAircraft extends AbstractByAircraft {

    constructor(props) {
        super(props);
        this.specificUri = 'ugo_log_archives';
        this.state = {
            resList: [],
            loading: true,
            currentPageNumber: 1,
            orderBy: 'ASC',
            currentFieldOrder: null,
            navigation: {
                totalItems: 0,
                first: '',
                next: '',
                last: '',
                totalPage: 0
            },
            error: {
                status: false,
                message: ''
            },
            anchor: '#ugolog',
            fieldsName: [
                'Archive Name',
                'Archive Type',
                'Creation Archive At',
                'Received on AWS s3 At',
                'Has been Uncompressed',
            ]
        };
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search)
        let currentFieldOrder;
        let orderBy = 'ASC'

        if (query.has('order[archiveName]')) {
            currentFieldOrder = 'Archive Name'
            orderBy = query.get('order[archiveName]')
        }
        if (query.has('order[archiveType]')) {
            currentFieldOrder = 'Archive Type'
            orderBy = query.get('order[archiveType]')
        }
        if (query.has('order[creationArchiveDatetime]')) {
            currentFieldOrder = 'Creation Archive At'
            orderBy = query.get('order[creationArchiveDatetime]')
        }
        if (query.has('order[s3CreationDatetime]')) {
            currentFieldOrder = 'Received on AWS s3 At'
            orderBy = query.get('order[s3CreationDatetime]')
        }
        if (query.has('order[hasBeenUncompressed]')) {
            currentFieldOrder = 'Has been Uncompressed'
            orderBy = query.get('order[hasBeenUncompressed]')
        }

        this.setState({
            currentFieldOrder,
            orderBy
        })

        this.getContentPage('?transportUnit.uuid=' + this.props.transportUnitUuid);
    }

    getProperty = (field) => {
        let property;

        switch (field) {
            case 'Archive Name':
                property = 'archiveName';
                break;
            case 'Archive Type':
                property = 'archiveType';
                break;
            case 'Creation Archive At':
                property = 'creationArchiveDatetime';
                break;
            case 'Received on AWS s3 At':
                property = 's3CreationDatetime';
                break;
            case 'Has been Uncompressed':
                property = 'hasBeenUncompressed';
                break;
            default:
                property = '';
        }

        return property;
    };

    isSimpleLinkOnShow = () => {
        return true;
    };

    getShowItemUrl = (fields) => {
        if (this.props.clickable) {
            const UgoLogArchiveUuid = fields[0]
            return `/${this.props.icao}/ugo-log-archive/${UgoLogArchiveUuid}`;
        }

        return '#';
    };

    getFields = () => {
        let fields = [];
        const resList = [...this.state.resList];

        resList.forEach(res => {
            let color = res.hasBeenUncompressed ? "success" : "danger"
            fields.push([
                res.uuid,
                res.archiveName,
                res.archiveType,
                res.creationArchiveDatetime,
                res.s3CreationDatetime,
                <span className={"label label-" + color }>{res.hasBeenUncompressed ? "Yes" : "No" }</span>
            ])
        });

        return fields;
    };
}

export default withRouter(UgoLogArchiveByAircraft);
